export enum AppointmentsContentVariant {
  SERVICE_TYPES = 'types',
  SERVICES = 'services',
}

export enum RegistrationContractAgreementStep {
  ENROLLMENT = 'enrollment',
  AGREEMENT = 'agreement',
}
